"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QRButton = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const StyledQRButton = styled_components_1.default.div `
    background-image: url("${require("../assets/mobile-icon.svg")}");
    width: 50px;
    height: 50px;
    position: absolute;
    right: 88px;
    bottom: 8px;
    z-index: 99999;
    cursor: auto;
    &:hover > div {
        transform: scale(1) translateY(0);
        opacity: 1;
    }
`;
const QRWrapper = styled_components_1.default.div `
    position: fixed;
    bottom: 88px;
    right: 18px;
    height: 388px;
    width: calc(256px + 32px);
    background: white;
    text-align: center;
    border-radius: 16px;
    transform: scale(0) translateY(300px);
    pointer-events: none;
    transform-origin: 70% 95%;
    opacity: 0;
    transition: all 0.2s cubic-bezier(0.36, 0.05, 0.8, 1.2);
    & > h3 {
        text-align: center;
        padding: 18px;
        display: block;
    }
    & > canvas {
        margin: auto;
        display: block;
        margin-bottom: 8px;
    }
`;
class QRButton extends react_1.Component {
    render() {
        return (react_1.default.createElement(StyledQRButton, null,
            react_1.default.createElement(QRWrapper, null,
                react_1.default.createElement("h3", null, "Mobile View"),
                react_1.default.createElement(qrcode_react_1.default, { value: this.props.mobileURL || window.location.href, size: 256 }),
                react_1.default.createElement("small", null, "Point your phone camera at the QR code"))));
    }
}
exports.QRButton = QRButton;
exports.default = QRButton;
